import "./style.scss";
import { FC, useMemo } from "react";
import { AOPSwitzerlandStudentData } from "@/src/types/admissionOffice";
import { getSwitzerlandStudentLetterBackground } from "../studentLetterSwissBackgrounds";

interface AOPPrevProps {
  bodyForPrev: AOPSwitzerlandStudentData;
}

const AOPPrev: FC<AOPPrevProps> = ({ bodyForPrev }) => {
  const actualBg = getSwitzerlandStudentLetterBackground(bodyForPrev.signature);
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";
  const photoUrl = useMemo(() => {
    if (!bodyForPrev.file) return null;
    return URL.createObjectURL(bodyForPrev.file);
  }, [bodyForPrev.file]);

  return (
    <div className="admission-office-prev-wrapper">
      <div className="admission-office-prev switzerland student-letter">
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section number-and-date">
          <span>№ - </span>
          <span>Date: {dateLine}</span>
        </div>
        <div className="admission-office-prev-section-file">
          {photoUrl ? <img src={photoUrl} alt="" className="admission-office-prev-photo" /> : null}
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName || ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth || ""}</p>
          <p>Nationality: {bodyForPrev.nationality || ""}</p>
          <p>Degree Program: {bodyForPrev.course || ""}</p>
          <p>Pasport Number: {bodyForPrev.passportNumber || ""}</p>
          <br />
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction || ""}</p>
          <p>Duration: {bodyForPrev.duration || ""}</p>
          <p>Academic Year: {bodyForPrev.academicYear || ""}</p>
          <p>Year of Study: {bodyForPrev.yearOfStudy || ""}</p>
          <p>Year Study Mode: {bodyForPrev.yearStudyMode || ""}</p>
        </div>
        {bodyForPrev.bodyStudentLetter?.length ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.bodyStudentLetter.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
